export default "__VITE_ASSET__ZhL9uzM4__"